import { categories, NODE_PRESENTATION } from './nodePresentationRegistry';

export default function NodePalette({ catalog, onAdd, disabled }) {
  const available = new Set((catalog?.node_types || []).map(item => item.type));
  return <aside className="cm-panel cm-palette" aria-label="Paleta de nodos">
    <div className="cm-panel-title"><h2>Nodos</h2><p>Agregá componentes al modelo.</p></div>
    {categories.map(category => <section key={category}>
      <h3>{category}</h3>
      <div className="cm-palette-list">
        {Object.entries(NODE_PRESENTATION)
          .filter(([type, item]) => item.category === category && available.has(type))
          .map(([type, item]) => {
            const Icon = item.icon;
            return <button type="button" key={type} disabled={disabled} onClick={() => onAdd(type)} title={item.description}>
              {Icon && <Icon size={17} aria-hidden="true" />}
              <span><strong>{item.label}</strong><small>{item.description}</small></span>
              <b aria-hidden="true">+</b>
            </button>;
          })}
      </div>
    </section>)}
  </aside>;
}

